module.exports = __webpack_public_path__ + "img/bg.f05efc3b.png";